import React, { Component } from 'react';
import { Link } from 'react-router';
import { Form, FormField, Input, Button, Translate } from '$common';
import Layout from './layout';



export default class Recover extends Component {
  render() {
    const { onSubmit } = this.props;

    return (
      <Layout
        title={Translate.get('reset_my_password')}
        type={'login'}
      >
        <Form onSubmit={onSubmit}>
          <FormField name="email" label={Translate.get('email')}>
            <Input type="email" />
          </FormField>
          <Button type="success" submit block>{Translate.get('reset_my_password')}</Button>
        </Form>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/recover.js